import { render } from "./PackageDownloadDropdown.vue?vue&type=template&id=562ad151&scoped=true"
import script from "./PackageDownloadDropdown.vue?vue&type=script&lang=js"
export * from "./PackageDownloadDropdown.vue?vue&type=script&lang=js"

import "./PackageDownloadDropdown.vue?vue&type=style&index=0&id=562ad151&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-562ad151"

export default script